export default {
    common: {
        noData: 'No data yet',
        copy: 'Copy',
        copySuccess: 'Copy successfully!',
        confirmText: 'Confirm',
        cancelText: 'Cancel',
        sendSuccess: 'Send successfully!',
        qrCodeDownloadApp: 'Download app'
    },
    login: {
        title: 'Login',
        enterUserName: 'Please enter your email/username',
        enterPassword: 'Please enter your password',
        enterLogin: 'Login',
        forgotPassword: 'Forgot password',
        register: 'Register account',
    },
    register: {
        title: 'Register',
        enterUserName: 'Username',
        enterPassword: 'Password',
        enterEmail: 'Email',
        enterCode: 'Email verification code',
        inviteCode: 'Invite code (optional)',
        sendEmailCode: 'Send verification code',
        enterUserNameErr: 'Please enter your username',
        enterUserNameErr2: 'Username consists of 6 to 16 letters or numbers',
        enterPasswordErr: 'Please enter your password',
        enterPasswordErr2: 'Password consists of 8 to 18 English letters, numbers, and special symbols',
        enterEmailErr: 'Please enter your email',
        enterEmailErr2: 'Please enter a valid email',
        enterCodeErr: 'Please enter your email verification code',
        enterRegister: 'Register',
        registerSuccess: 'Registration successful, you will be redirected to the login page...',
        toLogin: 'Already have an account? Log in directly',
        emailCodeTip: 'If you don\'t receive the email in your inbox, it may have been mistakenly identified as spam. Please check your spam folder.'
    },
    forgotPassword: {
        title: 'Forgot Password',
        enterEmail: 'Email',
        enterCode: 'Email Verification Code',
        sendEmailCode: 'Send Verification Code',
        enterEmailErr: 'Please enter your email',
        enterEmailErr2: 'Please enter a valid email',
        enterCodeErr: 'Please enter your email verification code',
        enterPassword: 'New Password',
        enterPasswordErr: 'Please enter your new password',
        enterPasswordErr2: 'The password consists of 8 to 18 English letters, numbers, and special symbols',
        enterBtn1: 'Cancel',
        enterBtn2: 'Confirm',
        forgotPasswordSuccess: 'Change successfully, and you will be redirected to the login page...'
    },
    layoutHeader: {
        login: 'Login',
        register: 'Register',
        nav: ['Market', 'Platform', 'Public Chain', 'Inscription', 'Liquidation', 'Smart Money', 'Long and Short', 'Whales', 'Rate', 'News', 'Application'],
        navHyperliquid: 'Hyperliquid Whale Monitor',
        userNav1: 'Sign in',
        userNav12: 'Wallet details',
        userNav2: 'Withdraw',
        userNav13: 'Withdrawal record',
        userNav3: 'Contract Check',
        userNav4: 'Invite Link',
        userNav5: 'Collection',
        userNav6: 'Tracking',
        userNav7: 'Team',
        userNav8: 'Tools',
        userNav9: 'Exit',
        userNav10: 'Binding API',
        userNav11: 'New robot',
        searchPlaceholder: 'Address or Currency Query',
        historyTitle: 'Historical Search Records',
        searchTitle1: 'Contract',
        searchTitle2: 'Currency',
        searchList1_1: 'Name',
        searchList1_2: 'Transaction',
        searchList1_3: 'Price',
        searchList2_1: 'Name',
        searchList2_2: 'Circulation',
        searchList2_3: 'Price',
        searchNoResult: 'No search results yet',
    },
    layoutTop: {
        topTitle1: 'Mainstream Coin Market Reference',
        topTitle2: 'Sentiment Index',
        sentimentIndexBlock1: 'Sentiment Index',
        sentimentIndexBlock1_1: 'Extreme Panic',
        sentimentIndexBlock1_2: 'Panic',
        sentimentIndexBlock1_3: 'Neutral',
        sentimentIndexBlock1_4: 'Greed',
        sentimentIndexBlock1_5: 'Extreme Greed',
        sentimentIndexBlock2: 'BTC Positions Long and Short',
        sentimentIndexBlock2_1: 'Bull Advantage',
        sentimentIndexBlock2_2: 'Bear Advantage',
        trend24h: '24h trend',
        past24h: 'Past 24 hours',
        candleSummary: 'BTC closing prices: last 48 half-hour candles',
        chartLoading: 'Loading chart…',
        chartUnavailable: 'Chart data is temporarily unavailable',
        sentimentDetails: 'View details',
        sentimentUnavailable: 'Unavailable',
        btcRatio: 'BTC long/short',
        ratioShare: 'Long {long}% · Short {short}%',
        moodHistory: 'History',
        moodRecentDays: 'Last {count} days',
        moodVsYesterday: '{value} vs yesterday',
        moodUnchanged: 'Unchanged vs yesterday',
    },
    layoutSection: {
        title1: 'Smart Money',
        title2: 'Assistive Tools',
        titleMore: 'More>>',
    },
    layoutFooter: {
        appTitle: 'Download a lot of apps',
        appNav1: 'Apps',
        appNav2: 'Wallet',
        appNav3: 'Social',
        explain1: 'Disclaimer:',
        explain2: 'All content on this website is from third-party platforms. We do not make any type of guarantee for the website and its content. All blockchain-related data and information on the website are for users\' learning and research purposes only and do not constitute any investment, legal or other field advice or basis. You need to use the relevant data and content with caution and bear all risks. It is strongly recommended that you research, review, analyze and verify the content on your own. ',
        copyright: '2026——The final right of interpretation belongs to TokenTrend'
    },
    coinDetails: {
        titleLabel1: '24-hour rise and fall',
        titleLabel2: '24-hour highest price',
        titleLabel3: '24-hour lowest price',
        titleLabel4: 'Trading volume',
        titleLabel5: 'Reported trading volume',
        titleLabel6: 'Historical highest price',
        titleLabel7: 'Historical lowest price',
        infoItem1: 'Currency:',
        infoItem2: 'Official website link:',
        infoItem3: '24H High Price:',
        infoItem4: '24H Low Price:',
        infoItem5: 'Circulation volume:',
        infoItem6: 'Total issuance volume:',
        infoItem7: 'Maximum issuance volume:',
        infoItem8: 'Listing time:',
        infoItem9: 'Price starting time:',
        infoItem10: 'White paper link:',
    },
    newCoinDetails: {
        titleLabel0: 'Direct link:',
        titleLabel1: 'Circulation volume',
        titleLabel2: 'Circulation rate',
        titleLabel3: 'Quantity issued',
        titleLabel4: 'Total amount issued',
        titleLabel5: '24-hour increase',
        titleLabel6: 'Latest price',
        titleLabel7: 'Sale price',
        titleLabel8: 'Pre-sale time',
        titleLabel9: 'Coin listing platform',
        titleLabel10: 'Sale ratio',
        listTitle: 'Market situation',
        list1: 'Trading platform',
        list2: 'Coin pair',
        list3: '24H trading volume',
        list4: '24H trading amount ($)',
        list5: 'Ratio',
    },
    platformDetails: {
        title: 'Platform details',
        website: 'Official website:',
        volume24h: '24H transaction volume:',
        riseFall24h: '24H rise and fall:',
        synopsis: 'Introduction',
        content1: 'Establishment time',
        content2: 'Registration place',
        content3: 'KYC certification',
        content4: 'Quantitative interface',
        content5: 'Assets',
        content6: 'Number of trading pairs',
        isTrue: 'Yes',
        isFalse: 'No',
        lastLinkTitle1: 'Transaction support',
        lastLinkTitle2: 'Related links',
        content8: 'Spot Trading',
        content9: 'Contract Trading',
        content10: 'OTC Trading',
        content11: 'Fiat Currency Trading',
        title3: 'Related Links',
        content12: 'Facebook',
        content13: 'Twitter',
        content14: 'Reddit',
        content15: 'Telegram',
    },
    firmOffer: {
        titleLabel0: 'Contract Address:',
        titleLabel1: 'Number of Token Holders',
        titleLabel2: 'Number of Unique Trading Addresses',
        titleLabel3: 'Number of Transactions',
        titleLabel4: 'Transaction Volume',
        titleLabel5: 'Liquidity',
        titleLabel6: 'Market Cap',
        titleLabel7: 'Creation Time',
        titleLabel8: 'Total Locked Market Cap',
        tabs1: 'Transaction History',
        tabs2: 'Pool Changes',
        tabs3: 'Token Holders',
        tabs4: 'My Position',
        transactionTh1: 'Time',
        transactionTh2: 'Type',
        transactionTh3: 'Quantity',
        transactionTh4: 'Price',
        transactionTh5: 'Total Value',
        transactionTh6: 'User Address',
        transactionTh7: 'Transaction Hash',
        tag1: 'Buy',
        tag2: 'Sell',
        tag3: 'Add',
        tag4: 'Remove',
        poolTip: 'The first pool data is displayed by default',
        poolTh1: 'Time',
        poolTh2: 'Type',
        poolTh3: 'Quantity/Token',
        poolTh4: 'Total Value',
        poolTh5: 'User Address',
        poolTh6: 'Transaction Hash',
        poolCurrent: 'Total Number of Token Holders',
        Explain1: 'Total Number of Token Holders:',
        Explain2: 'Top 10 Proportion:',
        Explain3: 'Sniper Count:',
        Explain4: 'Suspicious Token Holders:',
        positionTh1: 'Rank',
        positionTh2: 'Address',
        positionTh3: 'Ownership Percentage',
        positionTh4: 'Quantity',
        positionTh5: '24h Change',
        positionTh6: 'Block Information',
        financeType1: 'Top Buyers',
        financeType2: 'Top Sellers',
        financeTh1buy: 'Net Buy',
        financeTh1sell: 'Net Sell',
        financeTh2buy: 'Buy Amount ($)',
        financeTh2sell: 'Sell Amount ($)',
        financeTh3: 'User',
        addTrace: 'Are you sure you want to track this address?',
        addTraceSuccess: 'Successfully Added!',
    },    
    market: {
        tabs1: 'Hot',
        tabs2: 'Increase',
        tabs3: 'Decline',
        tabs4: 'New Coins',
        tabs5: 'Surging',
        tabs6: 'Market Cap',
        tabs7: 'Turnover',
        popularListTh0: 'No.',
        popularListTh1: 'Token',
        popularListTh2: 'Latest Price',
        popularListTh3: '24H Increase',
        popularListTh4: '24H Trading Volume',
        popularListTh5: '24H Turnover',
        popularListTh6: 'Circulating Market Cap',
        popularListTh7: 'Listing Time',
        // ETF related fields
        etfTh1: 'ETF Name',
        etfTh2: 'Fund Type',
        etfTh3: 'NAV (USD)',
        etfTh4: 'Premium (%)',
        etfTh5: 'BTC Holdings',
        etfTh6: 'Management Fee (%)',
        etfTh7: 'Volume (USD)',
        etfTh8: 'AUM (USD)',
    },
    platform: {
        tab1: 'Global Exchange Asset Ranking',
        ERGlobalRankingListTh1: 'Sort',
        ERGlobalRankingListTh2: 'Platform',
        ERGlobalRankingListTh3: 'Asset ($)',
        ERGlobalRankingListTh4: '24H transaction ($)',
        ERGlobalRankingListTh5: '24H rise and fall',
        ERGlobalRankingListTh6: 'Website',
    },
    publicChain: {
        tableTh1: 'Pair',
        tableTh2: 'Price/Volume', 
        tableTh3: 'Price Change/Market Cap',
        tableTh4: 'Number of Transactions',
        tableTh5: 'Trading Address/Token Holders',
        tableTh6: 'Liquidity/Time'
    },
    inscription: {
        typeAll: 'All',
        tableTh1: 'Token name',
        tableTh2: 'Holder',
        tableTh3: 'Total number of transactions',
    },
    burst: {
        title6: 'Clearing map',
        currentPrice: 'Current price：',
        liquidationTip1: 'Multiple clearing',
        liquidationTip2: 'Empty clearing',
        liquidationTip3: '10x lever',
        liquidationTip4: '25x lever',
        liquidationTip5: '50x lever',
        liquidationTip6: '100x lever',
        title1: 'Blowup heat map',
        heatmapTop: 'Based on the data of Binance, Huobi and OKX, the maximum point of {0}USDT blowup is around {1}, and the blowup value is {2}USDT. Please pay attention to the capital risk',
        heatmapDetailsBtn: 'Details',
        heatmapKLine1: 'K-line',
        heatmapKLine2: 'Intensity',
        heatmapTip1: 'Price',
        heatmapTip2: 'Liquidation intensity',
        kLineTip1: 'Opening price',
        kLineTip2: 'Closing price',
        kLineTip3: 'Highest price',
        kLineTip4: 'Lowest price',
        noLogin: 'Click on the upper right corner to log in, and you can view the heat map after logging in',
        title2: 'Blast data',
        topBlockH41: '4H burst',
        topBlockH42: '12H burst',
        topBlockH43: '24H burst',
        topBlockP1: 'Blast amount',
        topBlockP2: 'Long order ratio',
        title3: '24H burst ranking',
        rankingTh1: 'Exchange',
        rankingTh2: 'Currency',
        rankingTh3: 'Blast USD',
        rankingTh4: 'Long USD',
        rankingTh5: 'Short USD',
        title4: 'Blast statistics of each currency',
        title5: 'Blast ratio of all exchanges in the network',
        burstStatisticsHistoryTitle: 'Currency burst historical statistics',
        burstStatisticsHistoryTh1: 'Currency',
        burstStatisticsHistoryTh2: 'Long order burst',
        burstStatisticsHistoryTh3: 'Short order burst',
        burstStatisticsHistoryTh4: 'Time',
        heatmapDetailsTitle: 'Burst heat map data',
        heatmapDetailsList1Top: 'Short',
        heatmapDetailsList1Bottom: 'Long',
        heatmapDetailsList1: 'Direction',
        heatmapDetailsList2: 'Price',
        heatmapDetailsList3: 'Liquidation',
    },
    smartMoney: {
        typeTitle1: 'Top 100 High Frequency Trading',
        typMsg1: 'Top 100 Comprehensive Income/Rate of 8 Major Public Chains',
        typeTitle2: 'Celebrity Smart Money',
        typMsg2: 'Address Tracking of Global Celebrities/Public Chain Founders/Well-known Institutions',
        typeTitle3: 'First-level Smart Money',
        typMsg3: 'Smart Money with Higher/More Stable Rates in the Primary Market',
        typeTitle4: 'Custom Smart Money',
        typMsg4: 'Tracking Wallet Address Added by the User',
    },
    smartMoneyTop100: {
        topTip: 'Comprehensive analysis of the last 30 days of major DEX data. The balance is for reference only! ',
        sort: 'Sort',
        address: 'Address',
        amountUsd: 'Balance',
        floatProfit: 'Float profit',
        floatProfitPercent: 'Float profit rate',
        profit: 'Profit',
        profitPercent: 'Profit rate',
        collectTo: 'Collect',
        collectCancel: 'Cancel',
        noLogin: 'Log in to view and track the top 100 smart money with the highest returns in the world,',
        toLogin: 'Go to login',
    },
    smartMoneyStar: {
        th1: 'Name:',
        th2: 'Address:',
        th3: 'Time:',
    },
    smartMoneyOneLevel: {
        th1: 'Address:',
        th2: 'Time:',
    },
    smartMoneyCustom: {
        sort: 'Sort',
        name: 'Name',
        address: 'Address',
        time: 'Time',
        addNameRules: 'Please enter a name',
        addAddressRules: 'Please enter an address',
        addConfirm: 'Confirm',
        addSuccess: 'Added successfully! ',
        addBtn: 'Add custom',
        delBtn: 'Delete',
        delSuccess: 'Deleted successfully! ',
    },
    smartMoneyDetails: {
        type1: 'DEX',
        queryTokenAll: 'All',
        dexAddress: 'Address:',
        dexHash: 'Transaction hash:',
        dexChainName: 'Chain name:',
        dexTransactionAmount: 'Transaction value:',
        dexTrackerIn: 'Transfer to contract:',
        dexTrackerOut: 'Transfer to contract:',
        dexTrackerType: 'Transaction direction:',
        dexTrackerTypeCon: '{0}{1} converted to {2}{3}',
        dexTransactionTime: 'Transaction time:',
        type2: 'Ordinary',
        ordinaryHash: 'Transaction hash:',
        ordinaryTime: 'Time:',
        ordinaryFrom: 'Sender address:',
        ordinaryTo: 'Receiver address:',
        ordinarySymbol: 'Currency name:',
        ordinaryAmount: 'Transfer amount:',
    },
    manyEmpty: {
        title1: 'Global Account Long-Short Ratio',
        title2: 'Top Account Long-Short Ratio',
        title3: 'Top Account Long-Short Ratio',
        progress1: 'Long:',
        progress2: 'Short:',
        tableTh1: 'Exchange',
        tableTh2: 'Long-Short Ratio',
        tableTh3: 'Long Proportion',
        tableTh4: 'Short Proportion',
    },
    whale: {
        holdingsTitle: 'Grayscale holdings list',
        holdingsTitle2: 'Update time:',
        holdingsTh1: 'Position changes',
        holdingsTh1_1: '1 day',
        holdingsTh1_2: '7 days',
        holdingsTh1_3: '30 days',
        holdingsTh2: 'Premium rate',
        holdingsTh3: 'Number of holding currencies',
        holdingsTh4: 'Position value',
        contractTitle: 'Total contract holdings',
        contractTh1: 'Exchange',
        contractTh2: 'Position value ($)',
        contractTh3: 'Number of holdings',
        contractTh4: '15 minute changes',
        contractTh5: '1 day changes',
        exchangeTitle: 'Exchange balance list',
        exchangeTh1: 'Exchange',
        exchangeTh2: 'Number of wallets',
        exchangeTh3: '24H change',
        exchangeTh4: '7-day change',
        exchangeTh5: '30-day change',
        statistics1: 'Total market value:',
        statistics2: '24-hour trading volume:',
        statistics3: '24-hour highest price:',
        listRight1: 'Time',
        listRight2: 'Transfer address',
        listRight3: 'Transfer address',
        listRight4: 'Transfer amount',
    },
    rate: {
        newTitle: 'List of current exchange funding rates',
        newTableTh1: 'Currency',
        newTableTd1: 'Forecasted rates',
        oldTableTh1: 'Exchange',
        oldTableTh2: 'Current rates',
        oldTableTh3: 'Highest rates',
        oldTableTh4: 'Lowest rates',
        oldTableTh5: 'Update time',
    },
    consult: {
        nav1: 'News Briefs',
        nav2: 'Announcement',
        nav3: 'News',
        detailsTime: 'Time',
        detailsBack: 'Back',
        details: 'Details',
    },
    application: {
        nav1: 'App',
        nav2: 'Wallet',
        nav3: 'Social',
        visit: 'Visit',
        empty: 'Nothing here yet',
        download: 'Download',
        register: 'Register'
    },
    userSignIn: {
        alreadySignIn: 'Signed in for {0} days',
        signInBtn: 'Sign in now',
        tip1: "Browse the platform for {0} minutes to receive the sign-in reward",
        tip2: '(You have browsed for {0} minutes and {1} seconds)',
        success: 'Sign in successfully! ',
        recordTitle: 'Sign-in record',
        recordListContent: 'Time:',
    },
    userSignInRecord: {
        title: 'Wallet Details',
        selectAll: 'All',
        typeSelect1: 'Sign-in Rewards',
        typeSelect2: 'Direct Push Rewards',
        typeSelect3: 'Team Rewards',
        typeSelect4: 'Apply for Withdrawal Deductions',
        typeSelect5: 'System Rejected Increase',
        th1: 'Type',
        th2: 'Quantity',
        th3: 'Time',
    },
    userWithdrawal: {
        titleTip: 'The withdrawal address must be the wallet address of the TRON (TRC-20) chain. Filling in the wallet address of other chains will result in permanent loss and irrecoverable.',
        withdrawalAddress: 'Your withdrawal address:',
        inputWithdrawalAddress: 'Please enter the withdrawal address',
        number: 'Quantity',
        inputNumber: 'Please enter the quantity',
        inputNumberErr: 'Insufficient balance',
        balance: 'Balance',
        actualReceipt: 'Actual receipt:',
        gas: 'Service fee:',
        tip: 'Minimum withdrawal {0} USDT, withdrawal fee {1}%.',
        confirm: 'Confirm',
        explain: 'Network transactions take 0-2 hours, and network confirmation is not included',
        submitSuccess: 'Submission successful'
    },
    userWithdrawalRecord: {
        title: 'Withdrawal Record',
        list1: 'Address',
        list2: 'Network',
        list3: 'Coin',
        list4: 'Num',
        list5: 'Fee',
        list6: 'Status',
        list7: 'Time',
        status0: 'pending',
        status1: 'approved',
        status2: 'rejected',
    },
    userContractCheck: {
        enterPlaceholder: 'Please enter the contract address',
        enterBtn: 'Check',
        riskAssessment: 'Risk Assessment',
        riskInspection: 'Risk Check',
        checkNFT1: ['No malicious NFT', 'Malicious NFT'],
        checkNFT2: ['Not open source', 'Open source'],
        checkNFT3: ['No proxy contract', 'With proxy contract'],
        checkNFT4: ['Unverified', 'Verified'],
        checkNFT5: ['Not a well-known, trustworthy NFT', 'A well-known, trustworthy NFT'],
        checkToken1: ['Does not have the function of modifying the maximum transaction amount or maximum token holdings', 'Has the function of modifying the maximum transaction amount or maximum token holdings'],
        checkToken2: ['Ownership cannot be withdrawn', 'Ownership can be withdrawn'],
        checkToken3: ['Contract has no hidden owner', 'The contract has a hidden owner'],
        checkToken4: ['Does not have the function of limiting the maximum transaction volume or maximum position of a single address', 'Has the function of limiting the maximum transaction volume or maximum position of a single address'],
        checkToken5: ['The token is not a honeypot', 'The token is a honeypot'],
        checkToken6: ['The token cannot be traded on a decentralized exchange', 'The token can be traded on a decentralized exchange'],
        checkToken7: ['The contract does not have the ability to mint tokens', 'The contract has the ability to mint tokens'],
        checkToken8: ['Not open source', 'Open source'],
        checkToken9: ['Not an agent', 'An agent'],
        checkToken10: ['The contract owner cannot change the balance of the token holder', 'The contract owner can change the balance of the token holder'],
        checkToken11: ['You cannot set different tax rates for each assigned address', 'You can set different tax rates for each assigned address'],
        checkToken12: ['The contract cannot self-destruct', 'The contract can self-destruct'],
        checkToken13: ['The contract does not have a transaction cooling mechanism', 'The contract has a transaction cooling mechanism'],
        checkToken14: ['Trading cannot be suspended through the token contract', 'Trading can be suspended through the token contract'],
        checkToken15: ['The token is not a well-known and trusted token', 'The token is a well-known and trusted token'],
        botToken1: 'Owner address',
        botToken2: 'Owner\'s balance',
        botToken3: 'Percentage of tokens held by the owner',
        botToken4: 'Supply quantity',
        botNFT1: 'Total transaction volume',
        botNFT2: 'Number of holders',
        botNFT3: 'Highest price',
        botNFT4: '24-hour average price',
        botNFT5: '24-hour lowest price',
    },
    userCollect: {
        title: 'Collection',
        sort: 'Sort',
        address: 'Address',
        amountUsd: 'Balance',
        floatProfit: 'Floating profit',
        floatProfitPercent: 'Floating profit rate',
        profit: 'Profit',
        profitPercent: 'Profit rate',
        cancel: 'Cancel',
        cancelSuccess: 'Cancel successfully! ',
    },
    userTrace: {
        title: 'Tracking',
        th1: 'Sort',
        th2: 'Public chain name',
        th3: 'Token name',
        th4: 'Address',
        del: 'Delete',
        delSuccess: 'Deleted successfully! ',
    },
    userTeam: {
        title: 'Team',
        topInfo1: 'Direct people',
        topInfo2: 'Team people',
        topInfoUnit: 'People',
        th1: 'Username:',
        th2: 'Registration time:',
    },
    userTool: {
        tool1: 'BTC company holdings',
        tool2: 'Sentiment index',
        tool3: 'Mentougou monitoring',
        tool4: 'OTC price',
        tool5: 'Foreign market data',
        tool6: 'Large investors increase',
        tool7: 'Large investors reduce',
        tool8: 'Stable coins',
        tool9: 'Blockchain browser',
    },
    userToolCompanyHoldings: {
        title: 'Global company BTC holdings data',
        globalDataT1: 'BTC holding company',
        globalDataD1: 'Home',
        globalDataT2: 'Companys total positions',
        globalDataD2: '7D Changes:',
        globalDataT3: 'Total value of positions',
        globalDataD3: '7D Changes:',
        globalDataT4: 'Positions for BTC market',
        globalDataD4: 'Percentage 7D ago:',
        th1: 'Company name',
        th2: 'Holdings value ($)',
        th3: 'BTC market value',
        th4: 'BTC holdings',
        th5: '7D changes',
        th6: 'Total holding cost',
        th7: 'Average cost ($)',
    },
    userToolSentimentIndex: {
        title1: 'Fear and Greed Index',
        title1_1: 'Fear and Greed Index of BTC and Major Mainstream Coins',
        gauge1: 'Extreme Panic',
        gauge2: 'Panic',
        gauge3: 'Neutral',
        gauge4: 'Greed',
        gauge5: 'Extreme Greed',
        title2: 'Historical Index',
    },
    userToolMTGoxMonitor: {
        time: 'Update time:',
        title1: 'MTGox BTC cold wallet',
        topLabel1: 'Original total BTC held',
        topLabel1Span: 'Original value',
        topLabel2: 'Current total BTC remaining',
        topLabel2Span: 'Current value',
        topLabel3: 'Change in BTC held',
        title2: 'BTC cold wallet on-chain transfer record',
        th1: 'Transaction time',
        th2: 'Cold wallet address',
        th3: 'Amount of BTC transferred',
    },
    userToolOutsidePrice: {
        th1: 'Token name',
        th2: 'Exchange',
        th3: 'Average transaction price',
        th4: 'Premium',
    },
    userToolOutsideDisk: {
        itemTitleSpan: 'Update',
        itemTitle2: 'Opening time:',
        itemInfo1: 'Yesterday\'s closing',
        itemInfo2: 'Today\'s opening',
        itemInfo3: 'Today\'s trading volume',
        itemInfo4: 'Today\'s highest',
        itemInfo5: 'Today\'s lowest',
        itemInfo6: 'Highest in the past year',
        itemInfo7: 'Lowest in the past year',
    },
    userToolLargeIncrease: {
        title: 'Big investors increase their positions',
        titleMsg: 'Multiple or single currencies with different time periods, automatically calculate the currency\'s rise and fall in the selected time period',
        th1: 'Coin',
        th2: 'Chg.24H',
        th3: '24H ratio',
        th4: 'Weekly ratio',
        th5: 'Monthly ratio',
        th6: 'Global Index($)',
        th7: 'Top 10 ratio',
        th8: 'Top 20 ratio',
        th9: 'Top 50 ratio',
        th10: 'Top 100 ratio',
    },
    userToolLargeDecrease: {
        title: 'Big investors reduce their positions',
        titleMsg: 'Multiple or single currencies with different time periods, automatically calculate the currency\'s rise and fall in the selected time period',
        th1: 'Coin',
        th2: 'Chg.24H',
        th3: '24H ratio',
        th4: 'Weekly ratio',
        th5: 'Monthly ratio',
        th6: 'Global Index($)',
        th7: 'Top 10 ratio',
        th8: 'Top 20 ratio',
        th9: 'Top 50 ratio',
        th10: 'Top 100 ratio',
    },
    userToolStableCoin: {
        tab1: 'USDT market',
        UsdTopInfo1: 'USDT OTC average price',
        UsdTopInfo2: 'US dollar exchange rate',
        UsdTopInfo3: 'USDT premium rate',
        UsdTitleSub1: 'USDT related index trend',
        UsdTitleSub2: 'USDT premium related trend',
        UsdQuery1: '7 days',
        UsdQuery2: '30 days',
        tab2: 'Related stablecoins',
        relatedTitleSub1: 'Stablecoin overview',
        relatedTopTh1: 'Currency',
        relatedTopTh2: 'OTC average price ($)',
        relatedTopTh3: 'Premium rate',
        relatedTopTh4: 'Current circulation volume',
        relatedTopTh5: 'Circulation market value ($)',
        relatedQuery1: '30 days',
        relatedQuery2: 'Recent year',
        relatedTitleSub2: 'Stablecoin circulation',
        relatedTitleSub3: 'Percentage of stablecoin circulation',
        relatedTitleSub4: 'Stablecoin on-chain issuance',
        relatedBottomTh1: 'Time',
        relatedBottomTh2: 'Currency/mainnet',
        relatedBottomTh3: 'Issuance quantity',
        relatedBottomTh3_1: 'Increase issuance',
        relatedBottomTh3_2: 'Destruction',
        relatedBottomTh4: 'Transaction hash',
    },
    userToolBlockChainBrowser: {
        title: 'Blockchain Browser'
    },
    bindingApi: {
        bindBtn: 'Bind API',
        tip: 'Exchange creation API requires IP binding',
        listTitle: 'Binding list',
        list1: 'Unbind',
        list2: 'Available balance:',
        enterBourse: 'Select exchange:',
        enterNotes: 'Notes:',
        enterBourseErr: 'Please select exchange',
        enterApiKeyErr: 'Please enter API key',
        enterSecretKeyErr: 'Please enter Secret key',
        enterPassphraseErr: 'Please enter PassPhrase(OKX required)',
        enterNotesErr: 'Please enter notes',
        bindSubmit: 'Submit',
        bindSuccess: 'Binding success',
        unBindSuccess: 'Unbinding success'
    },
    hitNewRobot: {
        top1: 'leading the future of technology',
        top2: 'The new coin robot will be officially launched on September 30',
        topBtn: 'Game rules>>',
        hitNewTitle: 'Exchange new coin list',
        hitSelTitle: 'Please select a block',
        hitNewlistTh1: 'Token Information',
        hitNewlistTh2: 'Token Price',
        hitNewlistTh3: 'Initial Liquidity',
        hitNewlistTh4: 'Total Liquidity',
        hitNewlistTh5: 'Pool Amount',
        hitNewlistTh6: 'Pool',
        hitNewlistTh7: 'Remaining',
        hitNewlistTh8: 'Since Listing',
        createBtn: 'Create',
        createTitle: 'Create robot',
        createLabel1: 'Exchange name:',
        createLabel2: 'Coin pair name:',
        createLabel3: 'Coin listing time:',
        createLabel7: 'Available balance：',
        createLabel4: 'Quantity:',
        createLabel5: 'Price:',
        createLabel6: 'Buying time：',
        createLabel4Err: 'Please enter the estimated purchase quantity',
        createLabel5Err: 'Please enter the estimated purchase price',
        createLabel6Err: 'Please choose a time to purchase',
        createTip: 'The purchase value must be>=10 USDT',
        createSuccess: 'Created successfully! ',
        robotTitle: 'Robot List',
        robotListStatus1: 'To executed',
        robotListStatus2: 'Ended',
        robotListBinanceStatus1: 'Success',
        robotListBinanceStatus2: 'Failed',
        robotList1: 'Execution time:',
        robotList2: 'Cancel robot',
        robotList3: 'Coin pair',
        robotList4: 'Price',
        robotList5: 'Quantity',
        robotCancel: 'Cancel successfully',
    },
    hitNewRobotRule: {
        title: 'Return',
        h2_1: 'Core advantages:',
        label1_1: 'Efficient algorithm:',
        label1_2: 'Deep integration:',
        label1_3: 'Big data processing:',
        label1_4: 'Intelligent strategy:',
        label1_5: 'Security guarantee:',
        label1_6: 'Automated trading:',
        label1_7: 'Optimized experience:',
        p1_1: 'Built-in efficient algorithms, millisecond-level trading decisions, and accurate capture of market dynamics. ',
        p1_2: 'Integrate mainstream exchange APIs such as Binance, HTX, and OKX to ensure comprehensive and accurate data. ',
        p1_3: 'Use Apache Kafka and Flink technology to collect and process market data in real time. ',
        p1_4: 'Combined with TensorFlow or PyTorch framework, use historical data and trends to optimize new strategies. ',
        p1_5: 'Distributed architecture and multiple encryption technologies to ensure user data and transaction security. ',
        p1_6: 'Explore smart contracts and cross-chain technologies in the future to achieve DEX automated trading and efficient asset management. ',
        p1_7: 'Continuously optimize the interface and interactive design, provide intuitive data visualization tools, and enhance user experience. ',
        h2_2: 'Member upgrade standards:',
        label2_1: 'v0 → v1：',
        label2_2: 'v1 → v2：',
        label2_3: 'v2 → v3：',
        label2_4: 'v3 → v4：',
        label2_5: 'v4 → v5：',
        label2_6: 'v5 → v6：',
        label2_7: 'v6 → v7：',
        p2_1: 'Directly promote 3 people, the team reaches 100 people.',
        p2_2: 'Directly promote 5 people, the team reaches 200 people.',
        p2_3: 'Directly promote 5 people, two of whom reach v2.',
        p2_4: 'Directly promote 5 people, two of whom reach v3.',
        p2_5: 'Directly promote 5 people, two of whom reach v4.',
        p2_6: 'Directly promote 5 people, two of whom reach v5.',
        p2_7: 'Directly promote 5 people, two of whom reach v6.',
        h2_3: 'Robot distribution standard:',
        label3_1: 'V1',
        label3_2: 'V2',
        label3_3: 'V3',
        label3_4: 'V4',
        label3_5: 'V5',
        label3_6: 'V6',
        label3_7: 'V7',
        p3_1: 'Get 1 robot.',
        p3_2: 'Get 3 robots.',
        p3_3: 'Get 5 robots.',
        p3_4: 'Get 6 robots.',
        p3_5: 'Get 7 robots.',
        p3_6: 'Get 9 robots.',
        p3_7: 'Get 10 robots and get 5 more robots, a total of 15 robots.',
        h2_4: 'Robot effective operation conditions:',
        label4_1: 'Continuous sign-in:',
        label4_2: 'Activation conditions:',
        label4_3: 'Sign-in interruption:',
        p4_1: 'Members need to keep signing in every day to ensure the effective operation of the robot.',
        p4_2: 'Only members who sign in continuously can activate the new stock service. ',
        p4_3: 'If you miss the sign-in on the same day, the new stock robot will stop running the next day, and will automatically activate at midnight the next day after signing in again. ',
        h2_5: 'Summary:',
        p5: 'The digital currency new stock robot module of this platform provides members with automated, efficient and safe new stock services through efficient algorithms and intelligent strategies. With the continuous advancement of technology, we will continue to optimize the user experience, expand more diversified new stock options, and help members realize asset appreciation'
    },
    invite: {
        title: 'Invite friends',
        info1: 'Invite friends to join the registration/team',
        info2: 'Opportunity to get the opportunity to open the robot/promotion income',
        info3: 'Hi! Welcome to the TokenTrend platform',
        info4: 'Specially customized for newcomers in the coin circle, a new tool to get started with one click',
        btn: 'Copy the invitation link'
    },
    hyperliquid: {
        searchPlaceholder: 'Enter wallet address to query positions...',
        searchBtn: 'Search',
        title: 'Whale Position Monitor',
        dataCount: '{0} whale positions',
        long: 'Long',
        short: 'Short',
        cross: 'Cross',
        isolated: 'Isolated',
        positionValue: 'Position Value',
        positionSize: 'Position Size',
        entryPrice: 'Entry Price',
        markPrice: 'Mark Price',
        unrealizedPnl: 'Unrealized PnL',
        noData: 'No data',
        enterAddress: 'Please enter a wallet address',
        enterValidAddress: 'Please enter a valid wallet address',
        copyAddress: 'Copy address',
        whale: 'Whale',
        explorer: 'Explorer',
        accountTotalValue: 'Account Total Value',
        perpetual: 'Perpetual',
        freeMarginAvailable: 'Free Margin Available',
        withdrawable: 'Withdrawable',
        totalPositionValue: 'Total Position Value',
        leverageRatio: 'Leverage Ratio',
        marginUsed: 'Margin Used',
        usedRatio: 'Used Ratio',
        perpTotalValue: 'Perp Total Value',
        positionsCount: '{0} Positions',
        avgMarginUsedRatio: 'Average Margin Used Ratio',
        directionBias: 'Direction Bias',
        longExposure: 'Long Exposure',
        shortExposure: 'Short Exposure',
        positionDistribution: 'Position Distribution',
        longValue: 'Long Value',
        shortValue: 'Short Value',
        roe: 'ROE',
        upnl: 'uPnL',
        perpPositions: 'Perp Positions ({0})',
        symbol: 'Symbol',
        entryAvgPrice: 'Entry Avg. Price',
        margin: 'Margin',
        fundingCost: 'Funding Cost',
        noPositions: 'No positions found',
        userAddressRequired: 'User address is required',
        addressCopied: 'Address copied',
        copyFailed: 'Copy failed',
        bullish: 'Bullish',
        bearish: 'Bearish',
        neutral: 'Neutral'
    }
}